<template>
  <b-modal
    :title="`Asignarme Expediente ${file.numero}`"
    v-model="showModal"
    centered
    hide-footer
  >
    <div>
      Al asignarte el expediente serás responsable y podrás realizar acciones sobre éste
    </div>
    <div>
      <small>
        (Esta acción puede demorar unos segundos en completarse)
      </small>
    </div>
    <div
      class="m-top-20"
      style="display: flex;justify-content: flex-end;"
    >
      <vs-button
        color="dark"
        v-on:click="cancelAsign()"
        type="border"
      >Cancelar
      </vs-button>
      <vs-button
        v-on:click="asignFile()"
        color="primary"
        style="margin-left: 12px;"
        type="border"
      >
        Si, asignar
      </vs-button>
    </div>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'PopUpAsignFile',
  mixins: [],
  props: {
    file: {
      type: [Object],
      required: true,
      default: () => {
      }
    }
  },
  data() {
    const { view } = this.$route.params;
    return {
      view
    };
  },

  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    showModal: {
      get() {
        return this.modalName === 'asignFile';
      },
      set() {
        this.closeModal();
      }
    }
  },
  methods: {
    ...mapActions('Dnts', [
      'asignDntFileED'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    async asignFile() {
      await this.asignDntFileED({
        febosId: this.file.febosId,
        view: this.view
      });
      this.$emit('reload');
    },
    cancelAsign() {
      this.closeModal();
    }
  }
};
</script>
<style scoped>

</style>
